import { w as withConfigTransport } from "../../services/config-transport/withConfigTransport-31ef3979.mjs";
import { _ as _sfc_main } from "./VaValue.vue_vue_type_script_lang-23a7a5da.mjs";
const VaValue = withConfigTransport(_sfc_main);
export {
  VaValue as V
};
//# sourceMappingURL=index-ea28be0a.mjs.map
